import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconBrightness } from '../../../base/icons/svg';
import { inklusivaContextMenuStyles } from '../../../inklusiva/ui-constants';
import { BRIGHTNESS_SLIDER_MAXIMUM, BRIGHTNESS_SLIDER_MINIMUM } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        ...inklusivaContextMenuStyles(theme)
    };
});
const _onClick = (e) => {
    e.stopPropagation();
};
const BrightnessSlider = ({ initialValue, label, onChange }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const [brightness, setBrightness] = useState(initialValue || 100);
    const _onBrightnessSliderChange = useCallback((event) => {
        const newBrightness = event.currentTarget.value;
        onChange(newBrightness);
        setBrightness(Number(newBrightness));
    }, [onChange]);
    return (React.createElement("div", { "aria-label": t('brightnessSlider'), className: classes.contextMenuSlider },
        React.createElement("label", { className: classes.contextMenuSliderLabel, htmlFor: 'brightness-slider-input' }, label),
        React.createElement("div", { className: cx('popupmenu__contents', classes.contextMenuSliderInner), onClick: _onClick },
            React.createElement("span", { className: classes.contextMenuSliderIcon },
                React.createElement(Icon, { size: 22, src: IconBrightness })),
            React.createElement("input", { "aria-label": label, id: 'brightness-slider-input', "aria-valuemax": BRIGHTNESS_SLIDER_MAXIMUM, "aria-valuemin": BRIGHTNESS_SLIDER_MINIMUM, "aria-valuenow": brightness, max: BRIGHTNESS_SLIDER_MAXIMUM, min: BRIGHTNESS_SLIDER_MINIMUM, onChange: _onBrightnessSliderChange, tabIndex: 0, type: 'range', value: brightness }))));
};
export default BrightnessSlider;
